import { createFileRoute } from '@tanstack/react-router';
import { DeletionsPage } from '@/features/deletions';

export const Route = createFileRoute('/_auth/deletions')({
  component: DeletionsPage,
});
